import { config } from './config';
import { isAllowedUser } from './services/authPolicy';
import { requestSessionToken, shouldExpireSession } from './services/sessionFetch';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet, useNavigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';

// Pages communes
import Login from './pages/Login';
import SecuriteConnexion from './pages/SecuriteConnexion';
import Inscription from './pages/Inscription';
import Communaute from './pages/etudiant/Communaute';
import Statuts from './pages/etudiant/Statuts';

// Layouts
import AdminLayout from './layouts/AdminLayout';
import EnseignantLayout from './layouts/EnseignantLayout';
import EtudiantLayout from './layouts/EtudiantLayout';
import PatLayout from './pages/pat/PatLayout';
import RHLayout from './layouts/RHLayout';
import TechnicienLayout from './layouts/TechnicienLayout';
import ChargeLogementLayout from './layouts/ChargeLogementLayout';
import FinancierLayout from './layouts/FinancierLayout';
import InfirmierLayout from './layouts/InfirmierLayout';
import IntendantLayout from './layouts/IntendantLayout';
import MagasinierLayout from './layouts/MagasinierLayout';

// Pages Admin
import Dashboard from './pages/admin/Dashboard';
import Messagerie from './pages/admin/Messagerie';
import Etudiants from './pages/admin/Etudiants';
import Chambres from './pages/admin/Chambres';
import GestionPat from './pages/admin/GestionPat';
import Profil from './pages/admin/Profil';
import GestionClesPat from './pages/admin/GestionClesPat';

// Pages Enseignant
import DashboardEnseignant from './pages/enseignant/DashboardEnseignant';
import GererCours from './pages/enseignant/GererCours';
import GererPages from './pages/enseignant/GererPages';
import EditerPage from './pages/enseignant/EditerPage';
import StatistiquesCours from './pages/enseignant/StatistiquesCours';
import GestionFormations from './pages/enseignant/GestionFormations';
import ProfileEnseignant from './pages/enseignant/ProfileEnseignant';

// Pages Étudiant
import DashboardEtudiant from './pages/etudiant/DashboardEtudiant';
import MarcheCours from './pages/etudiant/MarcheCours';
import YouTubePlayer from './pages/etudiant/YouTubeChannel';
import MesAchats from './pages/etudiant/MesAchats';
import LecteurCours from './pages/etudiant/LecteurCours';
import AjouterProduit from './pages/etudiant/AjouterProduit';
import MesCartes from './pages/etudiant/MesCartes';
import TransactionsEtudiant from './pages/etudiant/TransactionsEtudiant';
import ProfileEtudiant from './pages/etudiant/ProfileEtudiant';
import RechargeCrou from './pages/etudiant/RechargeCrou';
import RechargePrincipal from './pages/etudiant/RechargePrincipal';
import TelechargerApplications from './pages/etudiant/TelechargerApplications';
import DemandeLogement from './pages/etudiant/DemandeLogement';
import StudioVideo from './pages/etudiant/StudioVideo';
import OutilsIA from './pages/etudiant/OutilsIA';

// ✅ PAGES BOUTIQUES
import Boutiques from './pages/etudiant/Boutiques';
import CreerBoutique from './pages/etudiant/CreerBoutique';
import BoutiqueDetail from './pages/etudiant/BoutiqueDetail';

// Pages PAT
import Activation from './pages/pat/Activation';
import Caisse from './pages/pat/Caisse';
import DashboardPat from './pages/pat/DashboardPat';
import TransactionsPat from './pages/pat/TransactionsPat';
import ProfilePat from './pages/pat/ProfilePat';
import DebitRepas from './pages/pat/DebitRepas';
import DebitBus from './pages/pat/DebitBus';
import MoyensPaiement from './pages/pat/MoyensPaiement';
import GererRechargesPat from './pages/pat/GererRechargesPat';

// Pages RH
import DashboardRH from './pages/rh/DashboardRH';
import GestionBus from './pages/rh/GestionBus';
import DashboardContractuels from './pages/rh/DashboardContractuels';
import GestionPrimes from './pages/rh/GestionPrimes';
import AttributionPrimes from './pages/rh/AttributionPrimes';
import SuppressionAttribution from './pages/rh/SuppressionAttribution';
import GestionAvancement from './pages/rh/GestionAvancement';

// Pages Charge Logement
import GestionLogements from './pages/charge_logement/GestionLogements';
import ProfileChargeLogement from './pages/charge_logement/ProfileChargeLogement';

// Pages Financier
import GestionProduits from './pages/financier/GestionProduits';
import ProgrammesTransport from './pages/financier/ProgrammesTransport';
import RapportsConsommation from './pages/financier/RapportsConsommation';
import ProfileFinancier from './pages/financier/ProfileFinancier';

// Pages Infirmier
import ConsultationEtudiant from './pages/infirmier/ConsultationEtudiant';
import ProfileInfirmier from './pages/infirmier/ProfileInfirmier';

// Pages Intendant
import GestionProduitsIntendant from './pages/intendant/GestionProduits';
import ProfileIntendant from './pages/intendant/ProfileIntendant';

// Pages Magasinier
import GestionDebitsMagasinier from './pages/magasinier/GestionDebits';
import ProfileMagasinier from './pages/magasinier/ProfileMagasinier';

// Feed & médias
import Feed from './pages/feed/Feed';
import ProfileMedia from './pages/profile/ProfileMedia';
import UserPosts from './pages/profile/UserPosts';

// TVSahel
import TVSahel from './pages/technicien/TVSahel';
import GestionTV from './pages/technicien/GestionTV';
import TechnicienDashboard from './pages/technicien/TechnicienDashboard';
import GererRechargesTechnicien from './pages/technicien/GererRechargesTechnicien';
import MoyensPaiementTechnicien from './pages/technicien/MoyensPaiementTechnicien';

// Pages Technicien
import NettoyagePosts from './pages/technicien/NettoyagePosts';
import GestionEtudiants from './pages/technicien/GestionEtudiants';
import EnvoyerMessageGlobal from './pages/technicien/EnvoyerMessageGlobal';
import GestionApplications from './pages/technicien/GestionApplications';

// Pages communes pour tous les rôles
import MessagesTechniques from './pages/MessagesTechniques';

// Pages Mairie
import Recensement from './pages/mairie/Recensement';
import GestionCollecteurs from './pages/mairie/GestionCollecteurs';
import PaiementContribuable from './pages/mairie/PaiementContribuable';
import Statistiques from './pages/mairie/Statistiques';
import ListeRecenses from './pages/mairie/ListeRecenses';
import GestionTaxes from './pages/mairie/GestionTaxes';
import StatistiquesCollecteurs from './pages/mairie/StatistiquesCollecteurs';
import GestionTechniciens from './pages/mairie/GestionTechniciens';

function rememberLoginIdentifier(user) {
    try {
        const identifier = user?.email || user?.telephone || user?.login || '';
        if (identifier) localStorage.setItem('last_login_identifier', identifier);
    } catch (error) {
        console.error('Erreur memorisation identifiant:', error);
    }
}

function clearExpiredSession(reason = 'expired') {
    try {
        const userStr = localStorage.getItem('user');
        if (userStr && userStr !== 'undefined') {
            rememberLoginIdentifier(JSON.parse(userStr));
        }
    } catch (error) {
        console.error('Erreur session expiree:', error);
    }
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.dispatchEvent(new CustomEvent('authChange', {
        detail: { isAuthenticated: false, reason }
    }));
    window.dispatchEvent(new Event('storage'));
}
// Hook personnalisé pour l'authentification
function useAuth() {
    const [authState, setAuthState] = useState({
        isAuthenticated: false,
        user: null,
        loading: true
    });

    const checkAuth = async () => {
        const token = localStorage.getItem('token');
        if (!token) { setAuthState({ isAuthenticated: false, user: null, loading: false }); return; }
        setAuthState({ isAuthenticated: false, user: null, loading: true });
        try {
            const response = await fetch(config.apiBase + '/auth/verify_token.php', {
                headers: { Authorization: 'Bearer ' + token }, cache: 'no-store'
            });
            const data = await response.json();
            if (localStorage.getItem('token') !== token) return;
            if (!response.ok || !data.success || !isAllowedUser(data.user)) {
                localStorage.removeItem('token'); localStorage.removeItem('user');
                setAuthState({ isAuthenticated: false, user: null, loading: false }); return;
            }
            localStorage.setItem('user', JSON.stringify(data.user));
            setAuthState({ isAuthenticated: true, user: data.user, loading: false });
        } catch (error) {
            setAuthState({ isAuthenticated: false, user: null, loading: false });
        }
    };

    useEffect(() => {
        checkAuth();
        
        const handleAuthChange = () => {
            checkAuth();
        };
        
        window.addEventListener('authChange', handleAuthChange);
        window.addEventListener('storage', handleAuthChange);
        
        return () => {
            window.removeEventListener('authChange', handleAuthChange);
            window.removeEventListener('storage', handleAuthChange);
        };
    }, []);

    return authState;
}

// Composant de redirection automatique
function AutoRedirect({ children, requiredRole, userRole }) {
    const navigate = useNavigate();
    
    useEffect(() => {
        if (!userRole) return;
        
        const roleRedirects = {
            'administrateur': '/admin',
            'enseignant': '/enseignant',
            'etudiant': '/etudiant',
            'pat': '/pat/dashboard',
            'rh': '/rh',
            'technicien': '/technicien',
            'charge_logements': '/logements',
            'financier': '/financier',
            'infirmier': '/infirmier',
            'intendant': '/intendant',
            'magasinier': '/magasin',
            'secretaire_administratif': '/secretaire',
            'chef_transport': '/transport'
        };
        
        if (requiredRole && userRole !== requiredRole) {
            const redirectPath = roleRedirects[userRole] || '/login';
            navigate(redirectPath, { replace: true });
        }
    }, [requiredRole, userRole, navigate]);

    return children;
}

// Composant ProtectedRoute avec support multi-rôles
function ProtectedRoute({ children, requiredRole, requiredRoles }) {
    const { isAuthenticated, loading, user } = useAuth();
    
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
            </div>
        );
    }
    
    if (!isAuthenticated || !isAllowedUser(user)) {
        return <Navigate to="/login" replace />;
    }
    
    if (requiredRoles && !requiredRoles.includes(user?.role)) {
        const roleRedirects = {
            'administrateur': '/admin',
            'enseignant': '/enseignant',
            'etudiant': '/etudiant',
            'pat': '/pat/dashboard',
            'rh': '/rh',
            'technicien': '/technicien',
            'charge_logements': '/logements',
            'financier': '/financier',
            'infirmier': '/infirmier',
            'intendant': '/intendant',
            'magasinier': '/magasin'
        };
        const redirectPath = roleRedirects[user?.role] || '/login';
        return <Navigate to={redirectPath} replace />;
    }
    
    if (requiredRole && user?.role !== requiredRole) {
        const roleRedirects = {
            'administrateur': '/admin',
            'enseignant': '/enseignant',
            'etudiant': '/etudiant',
            'pat': '/pat/dashboard',
            'rh': '/rh',
            'technicien': '/technicien',
            'charge_logements': '/logements',
            'financier': '/financier',
            'infirmier': '/infirmier',
            'intendant': '/intendant',
            'magasinier': '/magasin'
        };
        const redirectPath = roleRedirects[user?.role] || '/login';
        return <Navigate to={redirectPath} replace />;
    }
    
    return children;
}

function App() {
    const { isAuthenticated, user } = useAuth();

    useEffect(() => {
        const originalFetch = window.fetch.bind(window);
        window.fetch = async (...args) => {
            const sentToken = requestSessionToken(args[0], args[1]);
            const response = await originalFetch(...args);

            if (shouldExpireSession(response.status, args[0], sentToken, localStorage.getItem('token'))) {
                clearExpiredSession('expired');
                if (!window.location.pathname.includes('/login')) {
                    window.location.href = '/login?session=expired';
                }
            }

            return response;
        };

        return () => {
            window.fetch = originalFetch;
        };
    }, []);

    return (
        <BrowserRouter>
            <Toaster position="top-right" />

            <Routes>
                {/* ================= PUBLIC ================= */}
                <Route path="/login" element={<Login />} />
                <Route path="/inscription" element={<Inscription />} />
                <Route path="/tv-sahel" element={<ProtectedRoute><TVSahel /></ProtectedRoute>} />
                <Route path="/tv" element={<ProtectedRoute><TVSahel /></ProtectedRoute>} />

                {/* MESSAGERIE - PUBLIQUE */}
                <Route path="/messagerie" element={<ProtectedRoute><Messagerie /></ProtectedRoute>} />
                <Route path="/messages" element={<ProtectedRoute><Messagerie /></ProtectedRoute>} />

                {/* ================= MESSAGES TECHNIQUES ================= */}
                <Route 
                    path="/messages-techniques" 
                    element={
                        <ProtectedRoute>
                            <MessagesTechniques />
                        </ProtectedRoute>
                    } 
                />

                {/* ================= ADMIN ================= */}
                <Route
                    path="/admin/*"
                    element={
                        <ProtectedRoute requiredRole="administrateur" user={user}>
                            <AdminLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<Dashboard />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="etudiants" element={<Etudiants />} />
                    <Route path="chambres" element={<Chambres />} />
                    <Route path="pat" element={<GestionPat />} />
                    <Route path="profil" element={<Profil />} />
                    <Route path="cles-pat" element={<GestionClesPat />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                </Route>

                {/* ================= ENSEIGNANT ================= */}
                <Route
                    path="/enseignant/*"
                    element={
                        <ProtectedRoute requiredRole="enseignant" user={user}>
                            <EnseignantLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<DashboardEnseignant />} />
                    <Route path="formations" element={<GestionFormations />} />
                    <Route path="formations/:id" element={<GestionFormations />} />
                    <Route path="dashboard" element={<DashboardEnseignant />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="cours" element={<GererCours />} />
                    <Route path="cours/:idCours/pages" element={<GererPages />} />
                    <Route path="cours/:idCours/pages/:idPage/editer" element={<EditerPage />} />
                    <Route path="statistiques" element={<StatistiquesCours />} />
                    <Route path="profile" element={<ProfileEnseignant />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                </Route>

                {/* ================= ÉTUDIANT ================= */}
                <Route
                    path="/etudiant/*"
                    element={
                        <ProtectedRoute requiredRole="etudiant" user={user}>
                            <EtudiantLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<DashboardEtudiant />} />
                    <Route path="boutique/:id/ajouter-produit" element={<AjouterProduit />} />
                    <Route path="dashboard" element={<DashboardEtudiant />} />
                    <Route path="statuts" element={<Statuts />} />
                    <Route path="youtube" element={<YouTubePlayer />} />
                    <Route path="communaute" element={<Communaute />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="telecharger-applications" element={<TelechargerApplications />} />
                    <Route path="demande-logement" element={<DemandeLogement />} />
                    <Route path="recharge-crou" element={<RechargeCrou />} />
                    <Route path="recharge-principal" element={<RechargePrincipal />} />
                    <Route path="cours/marche" element={<MarcheCours />} />
                    <Route path="cours/mes-achats" element={<MesAchats />} />
                    <Route path="cours/:idCours/lire" element={<LecteurCours />} />
                    <Route path="mes-cartes" element={<MesCartes />} />
                    <Route path="transactions" element={<TransactionsEtudiant />} />
                    <Route path="profile" element={<ProfileEtudiant />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="studio-video" element={<StudioVideo />} />
                    <Route path="outils-ia" element={<OutilsIA />} />
                    <Route path="assistant-ia" element={<Navigate to="/etudiant/outils-ia" replace />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    
                    {/* ✅ ROUTES BOUTIQUES */}
                    <Route path="boutiques" element={<Boutiques />} />
                    <Route path="boutiques/creer" element={<CreerBoutique />} />
                    <Route path="boutique/:id" element={<BoutiqueDetail />} />
                </Route>

                {/* ================= PAT ================= */}
                <Route
                    path="/pat/*"
                    element={
                        <ProtectedRoute requiredRole="pat" user={user}>
                            <PatLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route path="activation" element={<Activation />} />
                    <Route path="caisse" element={<Caisse />} />
                    <Route path="debit-repas" element={<DebitRepas />} />
                    <Route path="recharges" element={<GererRechargesPat />} />
                    <Route path="debit-bus" element={<DebitBus />} />
                    <Route path="dashboard" element={<DashboardPat />} />
                    <Route path="transactions" element={<TransactionsPat />} />
                    <Route path="profile" element={<ProfilePat />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    <Route path="moyens-paiement" element={<MoyensPaiement />} />
                </Route>

                {/* ================= RH ================= */}
                <Route
                    path="/rh/*"
                    element={
                        <ProtectedRoute requiredRole="rh" user={user}>
                            <RHLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<DashboardRH />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="bus" element={<GestionBus />} />
                    <Route path="contractuels" element={<DashboardContractuels />} />
                    <Route path="primes" element={<GestionPrimes />} />
                    <Route path="attribution-primes" element={<AttributionPrimes />} />
                    <Route path="supprimer-attribution" element={<SuppressionAttribution />} />
                    <Route path="avancement" element={<GestionAvancement />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    <Route path="profil" element={<ProfilePat />} />
                </Route>

                {/* ================= TECHNICIEN ================= */}
                <Route
                    path="/technicien/*"
                    element={
                        <ProtectedRoute requiredRole="technicien" user={user}>
                            <TechnicienLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<TechnicienDashboard />} />
                    <Route path="dashboard" element={<TechnicienDashboard />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="gestion" element={<GestionTV />} />
                    <Route path="techniciens" element={<GestionTechniciens />} />
                    <Route path="gestion-applications" element={<GestionApplications />} />
                    <Route path="recharges" element={<GererRechargesTechnicien />} />
                    <Route path="statistiques" element={<TechnicienDashboard />} />
                    <Route path="moyens-paiement" element={<MoyensPaiementTechnicien />} />
                    <Route path="nettoyage-posts" element={<NettoyagePosts />} />
                    <Route path="gestion-etudiants" element={<GestionEtudiants />} />
                    <Route path="envoyer-message" element={<EnvoyerMessageGlobal />} />
                </Route>

                {/* ================= CHARGE LOGEMENT ================= */}
                <Route
                    path="/logements/*"
                    element={
                        <ProtectedRoute requiredRole="charge_logements" user={user}>
                            <ChargeLogementLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<GestionLogements />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="dashboard" element={<GestionLogements />} />
                    <Route path="gestion" element={<GestionLogements />} />
                    <Route path="demandes" element={<GestionLogements />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    <Route path="profil" element={<ProfileChargeLogement />} />
                </Route>

                {/* ================= FINANCIER ================= */}
                <Route
                    path="/financier/*"
                    element={
                        <ProtectedRoute requiredRole="financier" user={user}>
                            <FinancierLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<GestionProduits />} />
                    <Route path="rapports" element={<RapportsConsommation />} />
                    <Route path="transport" element={<ProgrammesTransport />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="dashboard" element={<GestionProduits />} />
                    <Route path="produits" element={<GestionProduits />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    <Route path="profil" element={<ProfileFinancier />} />
                </Route>

                {/* ================= INFIRMIER ================= */}
                <Route
                    path="/infirmier/*"
                    element={
                        <ProtectedRoute requiredRole="infirmier" user={user}>
                            <InfirmierLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<ConsultationEtudiant />} />
                    <Route path="profil" element={<ProfileInfirmier />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="consultation" element={<ConsultationEtudiant />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                </Route>

                {/* ================= INTENDANT ================= */}
                <Route
                    path="/intendant/*"
                    element={
                        <ProtectedRoute requiredRole="intendant" user={user}>
                            <IntendantLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<GestionProduitsIntendant />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="produits" element={<GestionProduitsIntendant />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                    <Route path="profil" element={<ProfileIntendant />} />
                </Route>

                {/* ================= MAGASINIER ================= */}
                <Route
                    path="/magasin/*"
                    element={
                        <ProtectedRoute requiredRole="magasinier" user={user}>
                            <MagasinierLayout />
                        </ProtectedRoute>
                    }
                >
                    <Route index element={<GestionDebitsMagasinier />} />
                    <Route path="messagerie" element={<Messagerie />} />
                    <Route path="profil" element={<ProfileMagasinier />} />
                    <Route path="stocks" element={<GestionDebitsMagasinier />} />
                    <Route path="debits" element={<GestionDebitsMagasinier />} />
                    <Route path="feed" element={<Feed />} />
                    <Route path="auteur/:idUtilisateur" element={<UserPosts />} />
                    <Route path="mes-medias" element={<ProfileMedia />} />
                </Route>

                {/* ================= MAIRIE ================= */}
                <Route
                    path="/mairie/*"
                    element={
                        <ProtectedRoute requiredRoles={['technicien', 'administrateur']} user={user}>
                            <div className="min-h-screen bg-gray-50">
                                <div className="max-w-7xl mx-auto px-4 py-4">
                                    <div className="flex items-center gap-2 mb-4">
                                        <h1 className="text-2xl font-bold text-gray-800">🏛️ Mairie</h1>
                                        <span className="text-sm text-gray-500">Gestion des taxes et recensement</span>
                                    </div>
                                    <div className="flex flex-wrap gap-2 mb-6">
                                        <button onClick={() => window.location.href = '/mairie/recensement'} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">📝 Recensement</button>
                                        <button onClick={() => window.location.href = '/mairie/collecteurs'} className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700">👥 Collecteurs</button>
                                        <button onClick={() => window.location.href = '/mairie/paiement'} className="px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">💰 Paiement</button>
                                        <button onClick={() => window.location.href = '/mairie/liste'} className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700">📋 Liste</button>
                                        <button onClick={() => window.location.href = '/mairie/taxes'} className="px-4 py-2 bg-cyan-600 text-white rounded hover:bg-cyan-700">🏷️ Taxes</button>
                                        <button onClick={() => window.location.href = '/mairie/statistiques'} className="px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700">📊 Statistiques</button>
                                        <button onClick={() => window.location.href = '/mairie/stats-collecteurs'} className="px-4 py-2 bg-pink-600 text-white rounded hover:bg-pink-700">📊 Collecteurs</button>
                                        <button onClick={() => window.location.href = '/mairie/techniciens'} className="px-4 py-2 bg-teal-600 text-white rounded hover:bg-teal-700">👨‍💻 Techniciens</button>
                                    </div>
                                    <Outlet />
                                </div>
                            </div>
                        </ProtectedRoute>
                    }
                >
                    <Route path="recensement" element={<Recensement />} />
                    <Route path="collecteurs" element={<GestionCollecteurs />} />
                    <Route path="paiement" element={<PaiementContribuable />} />
                    <Route path="techniciens" element={<GestionTechniciens />} />
                    <Route path="liste" element={<ListeRecenses />} />
                    <Route path="taxes" element={<GestionTaxes />} />
                    <Route path="statistiques" element={<Statistiques />} />
                    <Route path="stats-collecteurs" element={<StatistiquesCollecteurs />} />
                    <Route index element={<Recensement />} />
                </Route>

                {/* ================= AUTRES RÔLES ================= */}
                <Route
                    path="/secretaire/*"
                    element={
                        <ProtectedRoute requiredRole="secretaire_administratif" user={user}>
                            <div className="p-10 text-center">
                                <h1 className="text-2xl font-bold text-blue-700">📋 Espace Secrétariat</h1>
                                <p className="text-gray-600">Cette section sera bientôt disponible.</p>
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/transport/*"
                    element={
                        <ProtectedRoute requiredRole="chef_transport" user={user}>
                            <div className="p-10 text-center">
                                <h1 className="text-2xl font-bold text-blue-700">🚌 Espace Transport</h1>
                                <p className="text-gray-600">Cette section sera bientôt disponible.</p>
                            </div>
                        </ProtectedRoute>
                    }
                />

                <Route
                    path="/financier/assistant/*"
                    element={
                        <ProtectedRoute requiredRole="financier_assistant" user={user}>
                            <div className="p-10 text-center">
                                <h1 className="text-2xl font-bold text-blue-700">📋 Espace Assistant Financier</h1>
                                <p className="text-gray-600">Cette section sera bientôt disponible.</p>
                            </div>
                        </ProtectedRoute>
                    }
                />

                {/* ================= REDIRECTION ================= */}
                <Route path="/securite" element={<ProtectedRoute user={user}><SecuriteConnexion /></ProtectedRoute>} />
                <Route path="/" element={<Navigate to="/login" replace />} />
                <Route path="*" element={<Navigate to="/login" replace />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
